import { combineReducers } from 'redux';
import { reducers as collections } from '@fenderdigital/business/collections';
import favorites from './favorites';
import courses from './courses';
import intl from './intl';
import lessons from './lessons';
import myPath from './my-path';
import myProgress from './my-progress';
import paths from './paths';
import payWall from './payWall';
import plans from './plans';
import practice from './practice';
import pricing from './pricing';
import onboarding from './onboarding';
import relatedItems from './related-items';
import runtime from './runtime';
import search from './search';
import skills from './skills';
import skillsLists from './skills-lists';
import song from './song';
import songsLists from './songs-lists';
import stats from './stats';

const makeRootReducer = asyncReducers =>
  combineReducers({
    ...asyncReducers,
    collections,
    courses,
    favorites,
    intl,
    lessons,
    myPath,
    myProgress,
    onboarding,
    paths,
    payWall,
    plans,
    practice,
    pricing,
    relatedItems,
    runtime,
    search,
    skills,
    skillsLists,
    song,
    songsLists,
    stats,
  });

export const injectAsyncReducer = (store, key, reducer) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;
  /* eslint-disable no-param-reassign */
  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer(store.asyncReducers));
};

export default makeRootReducer;
